import { ContactAddress } from "@duosoftbg/nacid-components";

export const contactAddressInitialValues: ContactAddress = {
  address: "",
  city: "",
  country: { id: "", name: "" },
  settlement: { id: "", name: "", fullSettlementName: "" },
  phone: "",
  postCode: "",
  email: "",
  fax: "",
  postBox: "",
};
